import { render, staticRenderFns } from "./FormCustomTemplate.vue?vue&type=template&id=608d0ef5&"
import script from "./FormCustomTemplate.vue?vue&type=script&lang=js&"
export * from "./FormCustomTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports